import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./types";

export type AndrumSupabaseClient = SupabaseClient<Database>;

export type SupabasePublicConfig = {
 url: string;
 anonKey: string;
};

/**
 * Creates a typed browser/mobile Supabase client.
 * Pass only the public anon key - never the service role key.
 */
export function createBrowserClient(
 config: SupabasePublicConfig
): AndrumSupabaseClient {
 if (!config.url) {
 throw new Error("Missing Supabase URL");
 }
 if (!config.anonKey) {
 throw new Error("Missing Supabase anon key");
 }

 return createClient<Database>(config.url, config.anonKey, {
 auth: {
 persistSession: true,
 autoRefreshToken: true,
 detectSessionInUrl: true,
 flowType: "pkce",
 },
 });
}

/** Well-known cloud project for andrum (public URL only). */
export const ANDRUM_SUPABASE_PROJECT = {
 ref: "xpljvelpkawtrhujefwf",
 url: "https://xpljvelpkawtrhujefwf.supabase.co",
 dashboard:
 "https://supabase.com/dashboard/project/xpljvelpkawtrhujefwf",
} as const;
